'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  UNINITIALIZED: null,
  STARTED: null,
  SUCCEEDED: null,
  FAILED: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/RequestStatusTypes.js
// module id = 123
// module chunks = 0